import React from 'react';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', label = 'Loading' }) => {
  const sizeMap = {
    sm: 16,
    md: 24,
    lg: 32,
  };

  const dimension = sizeMap[size];

  const spinnerStyle: React.CSSProperties = {
    width: dimension,
    height: dimension,
    border: `3px solid var(--color-light-grey)`,
    borderTop: `3px solid var(--color-magenta)`,
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  };

  return (
    <>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <div style={spinnerStyle} role="status" aria-label={label} />
    </>
  );
};
